import type { GenderSummaryShellProps } from '@/modules/employer/pages/components/GenderSummaryShell/GenderSummaryShell.types'

import { GenderSummary } from '@/components/@Shared/UserManagmentCharts/GenderSummary/GenderSummary'

import { useEmployerStatsServiceEmployerStatsControllerGetGenderStats } from '@/__generated__/queries'

export function GenderSummaryShell({
  onUpdateChartsData,
}: GenderSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useEmployerStatsServiceEmployerStatsControllerGetGenderStats()

  return (
    <GenderSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
